// src/redux/communitySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const updateCommunitySection = createAsyncThunk(
    'community/update',
    async (sectionData) => {
        const user = localStorage.getItem('user');
        let token;
        if (user) {
            const parsedUser = JSON.parse(user);
            token = parsedUser.auth;
        }
        if (!token) {
            throw new Error('No authentication token found');
        }
        const data = new FormData();
        data.append('name', sectionData?.name);
        data.append('title', sectionData?.title);
        data.append('heading', sectionData?.heading);
        data.append('description', sectionData?.description);
        if (sectionData?.image) {
            data.append('image', sectionData?.image);
        }
        const config = {
            method: 'put',
            url: `${process.env.REACT_APP_API_ENDPOINT_URL}/commnunitysection/update/${sectionData?.id}`,
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            data: data,
        };

        try {
            const response = await axios.request(config);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "An unknown error occurred";
            throw new Error(errorMessage); 
        }
    }
);

const communitySlice = createSlice({
    name: 'community',
    initialState: {
        section: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateCommunitySection.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateCommunitySection.fulfilled, (state, action) => {
                state.loading = false;
                state.section = action.payload;
            })
            .addCase(updateCommunitySection.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default communitySlice.reducer;